import { ApiFundOfFundsPortfolio, ApiModelPortfolio, UserInformation } from 'api/rtk-api'

type Portfolio = ApiModelPortfolio | ApiFundOfFundsPortfolio

export function getImplicitPortfolioOwnerId(user?: UserInformation | null): string | undefined {
  if (!user) {
    return undefined
  }

  const isPmUser = user.roles[0] === 'PortfolioManager' && user.roles.length === 1
  const isBuPmUser =
    user.roles.includes('BusinessUnitUser') && user.roles.includes('PortfolioManager')

  return isPmUser || isBuPmUser ? user.organisation.organisationId : undefined
}

export function getEffectivePortfolioOwnerId(
  portfolio: { portfolioOwnerId?: string | null },
  user?: UserInformation | null
): string | undefined {
  return portfolio.portfolioOwnerId || getImplicitPortfolioOwnerId(user)
}

export function withResolvedPortfolioOwner<T extends Portfolio>(
  portfolio: T,
  user?: UserInformation | null
): T {
  return {
    ...portfolio,
    portfolioOwnerId: getEffectivePortfolioOwnerId(portfolio, user)
  }
}
